import { ReduceStore } from 'flux/utils';
import ACTION_TYPES from '../../constants/action_types';
import FilterOptionsConstants from '../../constants/filter_options_contants';
import { forOwn } from '../../../../lib/utilities';

export class CatalogFilterOptionsStoreClass extends ReduceStore {
    initFilterOptions(filters) {
        const initialCatalogFilterStoreState = {};

        filters.forEach(filter => {
            initialCatalogFilterStoreState[filter] = [];
            initialCatalogFilterStoreState[filter + 'Loading'] = false;
        });

        return initialCatalogFilterStoreState;
    }

    reduce(state, { source, action }) {
        let change = false;
        if (source === ACTION_TYPES.FILTER_OPTIONS_ACTION) {
            switch (action.type) {
                case FilterOptionsConstants.LOAD_FILTER_OPTIONS_ACTION:
                    Object.keys(action.payload).forEach(
                        (size) => {
                            if (!state[action.payload[size] + 'Loading']) {
                                state[action.payload[size] + 'Loading'] = change = true;
                            }
                        }
                    );
                    if (change) {
                        this.__emitChange();
                    }
                    break;

                case FilterOptionsConstants.UPDATE_FILTER_OPTIONS_ACTION:
                    forOwn(action.payload, (value, key) => {
                        if (typeof state[key] !== 'undefined') {
                            change = true;
                            state[key + 'Loading'] = false;
                            state[key] = value;
                        }
                    });

                    if (change) {
                        this.__emitChange();
                    }
                    break;
            }
        }

        return state;
    }
}
